<section class="container">
	<div class="row py-5">
		<div class="col-12 text-center">
			<h1 class="pb-4">{{ 'page-404-title' | translate }}</h1>
			<p class="pb-4">{{ 'page-404-text' | translate }}</p>
			<a routerLink="/">{{ 'page-404-link' | translate }}</a>
		</div>
	</div>
</section>
